module.exports = __webpack_public_path__ + "img/parameter.bf87ef4a.png";